export default "__VITE_ASSET__CpIXOk0b__"